import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { colorPalette } from '../../../../../colorPalette';
import { SellerLabel } from '../../../../Label';
import { AvatarLogo } from '../../../../AvatarLogo';
export const SellerBio = ({ seller }) => {
    var _a, _b;
    return (React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
        React.createElement(AvatarLogo, { logoUrl: seller === null || seller === void 0 ? void 0 : seller.eshopLogoUrl, width: "30px", height: "30px", iconSize: "16px", iconColor: colorPalette.gray700, isSeller: true }),
        React.createElement(Typography, { sx: {
                fontSize: '14px',
                fontWeight: 600,
                color: colorPalette.gray900,
            } }, seller === null || seller === void 0 ? void 0 : seller.eshopName),
        React.createElement(SellerLabel, { label: (seller === null || seller === void 0 ? void 0 : seller.isPro) ? 'Pro' : (seller === null || seller === void 0 ? void 0 : seller.isCrew) ? 'Site partenaire' : 'Particulier', isFrench: ((_b = (_a = seller === null || seller === void 0 ? void 0 : seller.legalNotice) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.countryName) === 'France' })));
};
